import { render } from "./PopupCapNhatPhienBan.vue?vue&type=template&id=2c01b5b4"
import script from "./PopupCapNhatPhienBan.vue?vue&type=script&lang=js"
export * from "./PopupCapNhatPhienBan.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__